import { HealthcareProviderP1IntegrationCertificateMetadata } from '@dreryk/egabinet-p1-frontend-api';

import { isDemo } from '@dreryk/demo-variant-frontend';
import {
   appendTestableElementAttributes,
   CertificateInfo,
   CertificateUpload,
   StyledFlex,
} from '@dreryk/react-components';

import { certificatesFormTranslationKeys } from '../../../../translations';
import {
   CertificatesFormController,
   useCertificateNotificationLabels,
   useMapCertificatesMetadataToCertificate,
} from '../P1CertificatesForm.hooks';

import { CERTIFICATE_VALIDATION_MESSAGES } from './common/common.utils';

type TlsCertificateUploadFieldProps = {
   readonly register: CertificatesFormController['register'];
   readonly tlsCertificateMetadata?: HealthcareProviderP1IntegrationCertificateMetadata;
   readonly p1CertificatesLoading: boolean;
};

const TlsCertificateUploadField = (props: TlsCertificateUploadFieldProps): JSX.Element => {
   const tlsCertificateMetadata = useMapCertificatesMetadataToCertificate(props.tlsCertificateMetadata);
   const tlsNotificationLabel = useCertificateNotificationLabels('tls');
   const isDemoMode = isDemo();
   const fileUploadPlaceholder = isDemoMode ? 'unavailableInDemo' : 'fileUploadPlaceholder';

   return (
      <StyledFlex gap={24} direction='column' {...appendTestableElementAttributes('tlsCertificateUpload')}>
         <CertificateInfo
            certificate={tlsCertificateMetadata}
            isLoading={props.p1CertificatesLoading}
            notificationLabels={tlsNotificationLabel}
            testId={'tlsCertificate'}
         />
         <CertificateUpload
            fileController={props.register('tlsCertificateFile')}
            passwordController={props.register('tlsCertificatePassword')}
            certificateLoading={props.p1CertificatesLoading}
            fileUploadLabel={certificatesFormTranslationKeys.tls.fileUploadLabel}
            fileUploadPlaceholder={certificatesFormTranslationKeys[fileUploadPlaceholder]}
            passwordLabel={certificatesFormTranslationKeys.tls.passwordLabel}
            validationMessages={CERTIFICATE_VALIDATION_MESSAGES}
            uploadDisabled={isDemoMode}
            testId={'tlsCertificateUpload'}
         />
      </StyledFlex>
   );
};

export { TlsCertificateUploadField };
